// extracted by mini-css-extract-plugin
export default {"MenuContainerDesktop":"MenuContainer_MenuContainerDesktop__f0NXr"};